import { connect } from 'react-redux';
import SendMessage from 'Components/Users/Usermgnt/SendMessage';

function mapStatetoProps(state){
    const { formLoading, errorElement } = state.domain
    return{
        formLoading,
        errorElement
    } 
}

const mapDispatchtoProps = {
}

export default connect(mapStatetoProps,mapDispatchtoProps)(SendMessage)